module.exports = __webpack_public_path__ + "static/media/LeftArrow.ee5e90d9.svg";